import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Alert } from 'antd'

import List from './List'
import AddRelated from './AddRelated'

@inject((store: any) => {
    const { popupStore, categoriesStore } = store
    return { popupStore, categoriesStore }
})
@observer
export default class RelatedCategories extends Component<any, any> {
    state: any = {
        errors: {}
    }

    closePopup = () => {
        this.setState({ errors: {} })
        this.props.popupStore.togglePopup(false)
    }

    setError = (type, message) => {
        if (!type) {
            this.setState({ errors: {} })
        } else {
            this.setState({ errors: { [type]: message } })
        }
    }

    render() {
        const { popupStore, categoriesStore } = this.props
        const { relatedCategories, relatedTo } = categoriesStore
        const categoryName = categoriesStore.indexedCategories[popupStore.info.id]
            ? categoriesStore.indexedCategories[popupStore.info.id].name
            : ''

        return (
            <Modal
                title={`קטגוריות מקושרות ל${categoryName}`}
                visible={popupStore.popupType === 'linkedCategories'}
                cancelText="סגור"
                onCancel={this.closePopup}
                okText="אישור"
                onOk={() => this.closePopup()}
            >
                <div>
                    {this.state.errors['serverError'] ? (
                        <Alert
                            message={this.state.errors['serverError']}
                            style={{ marginBottom: '0.5rem' }}
                            type="error"
                        />
                    ) : (
                        ''
                    )}
                </div>
                <div>
                    <AddRelated id={popupStore.info.id} error={(type, message) => this.setError(type, message)} />
                </div>
                <div style={{ marginTop: '1rem' }}>
                    <List
                        title="קטגוריות המשויכות לקטגוריה זו"
                        list={relatedCategories}
                        error={(type, message) => this.setError(type, message)}
                    />
                </div>
                <div style={{ marginTop: '1rem' }}>
                    <List
                        title="קטגוריות אליהן משוייכת קטגוריה זו"
                        list={relatedTo}
                        error={(type, message) => this.setError(type, message)}
                    />
                </div>
            </Modal>
        )
    }
}
